import { cn } from "@newxsystems/shared";
import { TootContactCard } from "../../../../modules/contact/components/TootContactCard/TootContactCard";
import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import type { IContactMethodsBlockProps } from "./ContactMethodsBlock.props";

const cardSpanClass = (index: number, total: number) => {
  if (total === 1) return "xl:col-span-6";
  if (total === 2 || total === 4) return "xl:col-span-3";
  if (total === 3) return "xl:col-span-2";
  return index < 2 ? "xl:col-span-3" : "xl:col-span-2";
};

export const ContactMethodsBlock = (props: IContactMethodsBlockProps) => {
  const { anchorId, buttons, contactMethods, eyebrow, heading, parentClass, spacing, subheading } =
    props;

  const methods = contactMethods ?? [];
  const actions = buttons ?? [];
  const hasHeader = Boolean(eyebrow || heading || subheading || actions.length > 0);

  if (!hasHeader && methods.length === 0) {
    return null;
  }

  return (
    <TootSectionShell
      className="grid gap-5"
      header={
        hasHeader ? (
          <TootHeading
            actions={
              actions.length > 0 ? <TootActions actions={actions} alignment="center" /> : undefined
            }
            alignment="center"
            eyebrow={eyebrow}
            heading={heading}
            subheading={subheading}
          />
        ) : undefined
      }
      id={anchorId ?? undefined}
      rootClassName={parentClass}
      spacing={spacing ?? undefined}
      width="wide"
    >
      {methods.length > 0 ? (
        <ul className="m-0 grid list-none gap-4 p-0 sm:grid-cols-2 xl:grid-cols-6">
          {methods.map((method, index) => (
            <li
              className={cn("min-w-0", cardSpanClass(index, methods.length))}
              key={`${method.type}-${method.label}-${index}`}
            >
              <TootContactCard
                actionLabel={method.link?.text ?? undefined}
                ariaLabel={method.link?.ariaLabel}
                className={cn(
                  "min-h-[16.5rem]",
                  index < 2 && methods.length > 3 && "min-h-[18rem]",
                )}
                description={method.description}
                href={method.link?.href}
                label={method.label}
                prominence={index < 2 && methods.length > 3 ? "primary" : "standard"}
                target={method.link?.target}
                type={method.type}
                value={method.value}
              />
              {method.action ? <TootActions actions={[method.action]} className="mt-3" /> : null}
            </li>
          ))}
        </ul>
      ) : null}
    </TootSectionShell>
  );
};

ContactMethodsBlock.displayName = "Block::ContactMethodsBlock";
